/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Box,
  Grid,
  Card,
  CardMedia,
  CardActionArea,
  CardContent,
  CardHeader,
  CardActions,
  TextField,
  Typography,
  Stack,
  MenuItem
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import SettingAction from '../../../store/actions/SettingAction';
import globalAction from '../../../store/actions/GlobalAction';
import Loader from '../../../utils/errorPages/Loader';

function OfficeAddressView() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataItem, setDataItem] = useState('');
  const [images, setImages] = React.useState([]);
  const { officeItemData, isLoading } = useSelector((state) => state.setting);
  const { statusData } = useSelector((state) => state.global);
  const { REACT_APP_API_URL } = process.env;
  const { code } = useParams();

  useEffect(() => {
    dispatch(globalAction.getClientStatus());
    dispatch(SettingAction.getOfficeItem(code));
  }, [dispatch, code]);

  useEffect(() => {
    if (officeItemData && officeItemData !== undefined) {
      setDataItem(officeItemData);
    }
  }, [officeItemData]);

  useEffect(() => {
    if (dataItem && dataItem !== undefined && dataItem !== '') {
      if (dataItem.logo && dataItem.logo !== undefined) {
        const arrValue = [];
        const arrObject = {
          path: dataItem.logo
        };
        arrValue.push(arrObject);
        setImages(arrValue);
      }
    }
  }, [dataItem]);

  const initialValues = {
    address_type: dataItem?.address_type ?? '',
    short_code: dataItem?.short_code ?? '',
    full_address: dataItem?.full_address ?? '',
    status: dataItem?.status ?? '',
    logo: []
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      {isLoading ? <Loader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/settings/bank">
            Office Address
          </Typography>
          <Typography component="h2" variant="h2">
            / View
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={initialValues}
        // validationSchema={ValidateBankDetails}
        enableReinitialize
        onSubmit={{}}
      >
        {({ errors, touched, values, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader title="Address Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={2}>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="address_type"
                          disabled
                          name="address_type"
                          label="Address Type"
                          variant="outlined"
                          value={values.address_type}
                          margin="normal"
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                            handleBlur(e);
                          }}
                          error={touched.address_type && Boolean(errors.address_type)}
                          helperText={touched.address_type && errors.address_type}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="short_code"
                          disabled
                          name="short_code"
                          label="Short Code"
                          variant="outlined"
                          value={values.short_code}
                          margin="normal"
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                            handleBlur(e);
                          }}
                          error={touched.short_code && Boolean(errors.short_code)}
                          helperText={touched.short_code && errors.short_code}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <div className="upload__image-wrapper">
                          {images && images.length > 0
                            ? images.map((image, index) => {
                                return (
                                  <Card
                                    sx={{
                                      mt: 0,
                                      width: '100%',
                                      border: '1px dashed rgba(20,20,20,0.75)'
                                    }}
                                    key={index}
                                  >
                                    <CardActionArea sx={{ position: 'relative', p: '20px' }}>
                                      <CardMedia
                                        component="img"
                                        height="100"
                                        image={
                                          image.path
                                            ? `${REACT_APP_API_URL}/${image.path}`
                                            : image.data_url
                                        }
                                        alt="green iguana"
                                        // onClick={() => onImageUpdate(index)}
                                      />
                                    </CardActionArea>
                                  </Card>
                                );
                              })
                            : ''}
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={2}>
                      <Grid item md={5} lg={5} xl={4}>
                        <TextField
                          fullWidth
                          id="full_address"
                          name="full_address"
                          label="Full Address"
                          variant="outlined"
                          disabled
                          multiline
                          rows={3}
                          margin="none"
                          onChange={handleChange}
                          value={values.full_address}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.full_address && Boolean(errors.full_address)}
                          helperText={touched.full_address && errors.full_address}
                        />
                      </Grid>
                    </Grid>
                    <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={2}>
                      <Grid item md={2} lg={2} xl={2}>
                        <TextField
                          id="status"
                          fullWidth
                          label="Status"
                          name="status"
                          margin="normal"
                          disabled
                          select
                          value={values.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.status && touched.status}
                          helperText={errors.status && touched.status && errors.status}
                        >
                          {statusData &&
                            statusData.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.status}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate('/settings');
                      }}
                    >
                      Back
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
export default OfficeAddressView;
